import { createI18n } from "@rekati/i18n";
import { en } from "./en";
import { id } from "./id";

// Indonesian unless the attendee chooses English (a ?lang=en link or the
// switch): the language sent with the registration, and so the emails'.
// The key moved from "rekati.register.lang" so a language stored from the
// browser's setting before this default is not mistaken for a choice.
export const { I18nProvider, useI18n } = createI18n({ en, id }, "rekati.register.lang.v2", "id");
